import axios from "axios";

export const automationClient = axios.create({
  baseURL: `${process.env.REACT_APP_CALLING_CONFIGURATION_BACKEND_URL}`,
  responseType: "json",
  timeout: 100000,
});

automationClient.interceptors.request.use(
  (config) => {
    config.headers["x-api-key"] = `${process.env.REACT_APP_X_API_KEY_PUBLIC}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
